// import l0 from './anytime-fitness.webp';
import l147 from './Group 427323603.png';
import l49 from './Group 427323505.png';
import l20 from './Group 427323476.png';
import l21 from './Group 427323477.png';
import l17 from './exedy.png';
import l1 from './Group 427323457.png';
import l2 from './Group 427323458.png';
import l3 from './Group 427323459.png';
import l4 from './Group 427323460.png';
import l5 from './Group 427323461.png';
import l6 from './Group 427323462.png';
import l7 from './Group 427323463.png';
import l8 from './Group 427323464.png';
import l9 from './Group 427323465.png';
import l10 from './Group 427323466.png';
import l11 from './Group 427323467.png';
import l12 from './Group 427323468.png';
import l13 from './Group 427323469.png';
import l14 from './Group 427323470.png';
import l15 from './Group 427323471.png';
import l16 from './Group 427323472.png';
import l18 from './Group 427323474.png';
import l19 from './Group 427323475.png';

import l22 from './Group 427323478.png';
import l23 from './Group 427323479.png';
import l24 from './Group 427323480.png';
import l25 from './Group 427323481.png';
import l26 from './Group 427323482.png';
import l27 from './Group 427323483.png';
import l28 from './Group 427323484.png';
import l29 from './Group 427323485.png';
import l30 from './Group 427323486.png';
import l31 from './Group 427323487.png';
import l32 from './Group 427323488.png';
import l33 from './Group 427323489.png';
import l34 from './Group 427323490.png';
import l35 from './Group 427323491.png';
// import l36 from './Group 427323492.png';
import l37 from './Group 427323493.png';
import l38 from './Group 427323494.png';
// import l39 from './Group 427323495.png';
import l40 from './Group 427323496.png';
import l41 from './Group 427323497.png';
import l42 from './Group 427323498.png';
import l43 from './Group 427323499.png';
import l44 from './Group 427323500.png';
import l45 from './Group 427323501.png';
import l46 from './Group 427323502.png';
import l47 from './Group 427323503.png';
import l48 from './Group 427323504.png';
import l50 from './Group 427323506.png';
import l51 from './Group 427323507.png';
import l52 from './Group 427323508.png';
import l53 from './Group 427323509.png';
import l54 from './Group 427323510.png';
import l55 from './Group 427323511.png';
import l56 from './Group 427323512.png';
import l57 from './Group 427323513.png';
import l58 from './Group 427323514.png';
import l59 from './Group 427323515.png';
import l60 from './Group 427323516.png';
import l61 from './Group 427323517.png';
import l62 from './Group 427323518.png';
import l63 from './Group 427323519.png';
import l64 from './Group 427323520.png';
import l65 from './Group 427323521.png';
import l66 from './Group 427323522.png';
import l67 from './Group 427323523.png';
import l68 from './Group 427323524.png';
// import l69 from './Group 427323525.png';
import l70 from './Group 427323526.png';
import l71 from './Group 427323527.png';
import l72 from './Group 427323528.png';
import l73 from './Group 427323529.png';
import l74 from './Group 427323530.png';
import l75 from './Group 427323531.png';
import l76 from './Group 427323532.png';
import l77 from './Group 427323533.png';
import l78 from './Group 427323534.png';
import l79 from './Group 427323535.png';
import l80 from './Group 427323536.png';
import l81 from './Group 427323537.png';
import l82 from './Group 427323538.png';
import l83 from './Group 427323539.png';
import l84 from './Group 427323540.png';
import l85 from './Group 427323541.png';
import l86 from './Group 427323542.png';
import l87 from './Group 427323543.png';
import l88 from './Group 427323544.png';
// import l89 from './Group 427323545.png';
import l90 from './Group 427323546.png';
import l91 from './Group 427323547.png';
import l92 from './Group 427323548.png';
import l93 from './Group 427323549.png';
import l94 from './Group 427323550.png';
import l95 from './Group 427323551.png';
import l96 from './Group 427323552.png';
import l97 from './Group 427323553.png';
import l98 from './Group 427323554.png';
import l99 from './Group 427323555.png';
import l100 from './Group 427323556.png';
import l101 from './Group 427323557.png';
import l102 from './Group 427323558.png';
import l103 from './Group 427323559.png';
import l104 from './Group 427323560.png';
import l105 from './Group 427323561.png';
import l106 from './Group 427323562.png';
// import l107 from './Group 427323563.png';
import l108 from './Group 427323564.png';
import l109 from './Group 427323565.png';
import l110 from './Group 427323566.png';
import l111 from './Group 427323567.png';
import l112 from './Group 427323568.png';
import l113 from './Group 427323569.png';
import l114 from './Group 427323570.png';
import l115 from './Group 427323571.png';
import l116 from './Group 427323572.png';
import l117 from './Group 427323573.png';
import l118 from './Group 427323574.png';
import l119 from './Group 427323575.png';
import l120 from './Group 427323576.png';
import l121 from './Group 427323577.png';
import l122 from './Group 427323578.png';
import l123 from './Group 427323579.png';
import l124 from './Group 427323580.png';
import l125 from './Group 427323581.png';
import l126 from './Group 427323582.png';
import l127 from './Group 427323583.png';
// import l128 from './Group 427323584.png';
import l129 from './Group 427323585.png';
import l130 from './Group 427323586.png';
import l131 from './Group 427323587.png';
import l132 from './Group 427323588.png';
import l133 from './Group 427323589.png';
import l134 from './Group 427323590.png';
import l135 from './Group 427323591.png';
import l136 from './Group 427323592.png';
import l137 from './Group 427323593.png';
import l138 from './Group 427323594.png';
import l139 from './Group 427323595.png';
import l140 from './Group 427323596.png';
import l141 from './Group 427323597.png';
import l142 from './Group 427323598.png';
import l143 from './Group 427323599.png';
import l144 from './Group 427323600.png';
import l145 from './Group 427323601.png';
import l146 from './Group 427323602.png';
import l148 from './Group 427323604.png';
import l149 from './Group 427323605.png';
import l150 from './Group 427323606.png';
import l151 from './Group 427323607.png';
import l152 from './Group 427323608.png';
import l153 from './Group 427323609.png';
import l154 from './Group 427323610.png';
import l155 from './Group 427323611.png';
import l156 from './Group 427323612.png';
import l157 from './Group 427323613.png';
// import l158 from './Group 427323614.png';
import l159 from './Group 427323615.png';
import l160 from './Group 427323616.png';
// import l161 from './Group 427323437.jpg';

const files = [['Group 427323603', l147],['Group 427323505', l49],['Group 427323476', l20],['Group 427323477', l21],['exedy', l17],
  ['Group 427323457', l1], ['Group 427323458', l2], ['Group 427323459', l3], ['Group 427323460', l4],
  ['Group 427323461', l5], ['Group 427323462', l6], ['Group 427323463', l7], ['Group 427323464', l8],
  ['Group 427323465', l9], ['Group 427323466', l10], ['Group 427323467', l11], ['Group 427323468', l12],
  ['Group 427323469', l13], ['Group 427323470', l14], ['Group 427323471', l15], ['Group 427323472', l16],
  ['Group 427323474', l18], ['Group 427323475', l19], 
   ['Group 427323478', l22], ['Group 427323479', l23], ['Group 427323480', l24],
  ['Group 427323481', l25], ['Group 427323482', l26], ['Group 427323483', l27], ['Group 427323484', l28],
  ['Group 427323485', l29], ['Group 427323486', l30], ['Group 427323487', l31], ['Group 427323488', l32],
  ['Group 427323489', l33], ['Group 427323490', l34], ['Group 427323491', l35], 
  ['Group 427323493', l37], ['Group 427323494', l38],  ['Group 427323496', l40],
  ['Group 427323497', l41], ['Group 427323498', l42], ['Group 427323499', l43], ['Group 427323500', l44],
  ['Group 427323501', l45], ['Group 427323502', l46], ['Group 427323503', l47], ['Group 427323504', l48],
   ['Group 427323506', l50], ['Group 427323507', l51], ['Group 427323508', l52],
  ['Group 427323509', l53], ['Group 427323510', l54], ['Group 427323511', l55], ['Group 427323512', l56],
  ['Group 427323513', l57], ['Group 427323514', l58], ['Group 427323515', l59], ['Group 427323516', l60],
  ['Group 427323517', l61], ['Group 427323518', l62], ['Group 427323519', l63], ['Group 427323520', l64],
  ['Group 427323521', l65], ['Group 427323522', l66], ['Group 427323523', l67], ['Group 427323524', l68],
   ['Group 427323526', l70], ['Group 427323527', l71], ['Group 427323528', l72],
  ['Group 427323529', l73], ['Group 427323530', l74], ['Group 427323531', l75], ['Group 427323532', l76],
  ['Group 427323533', l77], ['Group 427323534', l78], ['Group 427323535', l79], ['Group 427323536', l80],
  ['Group 427323537', l81], ['Group 427323538', l82], ['Group 427323539', l83], ['Group 427323540', l84],
  ['Group 427323541', l85], ['Group 427323542', l86], ['Group 427323543', l87], ['Group 427323544', l88],
   ['Group 427323546', l90], ['Group 427323547', l91], ['Group 427323548', l92],
  ['Group 427323549', l93], ['Group 427323550', l94], ['Group 427323551', l95], ['Group 427323552', l96],
  ['Group 427323553', l97], ['Group 427323554', l98], ['Group 427323555', l99], ['Group 427323556', l100],
  ['Group 427323557', l101], ['Group 427323558', l102], ['Group 427323559', l103], ['Group 427323560', l104],
  ['Group 427323561', l105], ['Group 427323562', l106], ['Group 427323564', l108],
  ['Group 427323565', l109], ['Group 427323566', l110], ['Group 427323567', l111], ['Group 427323568', l112],
  ['Group 427323569', l113], ['Group 427323570', l114], ['Group 427323571', l115], ['Group 427323572', l116],
  ['Group 427323573', l117], ['Group 427323574', l118], ['Group 427323575', l119], ['Group 427323576', l120],
  ['Group 427323577', l121], ['Group 427323578', l122], ['Group 427323579', l123], ['Group 427323580', l124],
  ['Group 427323581', l125], ['Group 427323582', l126], ['Group 427323583', l127], 
  ['Group 427323585', l129], ['Group 427323586', l130], ['Group 427323587', l131], ['Group 427323588', l132],
  ['Group 427323589', l133], ['Group 427323590', l134], ['Group 427323591', l135], ['Group 427323592', l136],
  ['Group 427323593', l137], ['Group 427323594', l138], ['Group 427323595', l139], ['Group 427323596', l140],
  ['Group 427323597', l141], ['Group 427323598', l142], ['Group 427323599', l143], ['Group 427323600', l144],
  ['Group 427323601', l145], ['Group 427323602', l146], ['Group 427323604', l148],
  ['Group 427323605', l149], ['Group 427323606', l150], ['Group 427323607', l151], ['Group 427323608', l152],
  ['Group 427323609', l153], ['Group 427323610', l154], ['Group 427323611', l155], ['Group 427323612', l156],
  ['Group 427323613', l157],  ['Group 427323615', l159], ['Group 427323616', l160],
];

const logos = files.map(([name, src]) => ({ src, alt: name }));

export default logos;
